import styled from "styled-components";

export const InventoryAuditContainer = styled.div`
    background-color: white;
    padding: 0px 16px;
`;

export const InventaryFilterContainer = styled.div`
    padding: 16px; 
    border-bottom: 1px solid rgba(118, 127, 141, 0.1);
`;

export const TopInventaryFilterContent = styled.div`
    display: flex;
    gap: 12px;
    width: max-content;
    .ant-input-suffix{
        margin-bottom: 6px !important;
    }
`;

export const TopInventaryFilterTagContent = styled.div`
    margin-top: 12px;
`;

export const LoadingMask = styled.div`
    inset: 0;
    z-index: 1001;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
`;

